const TOKEN_KEY = "targetcalc_access_token";
const ROLE_KEY = "targetcalc_role";
const ACCOUNT_ID_KEY = "targetcalc_account_id";

const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error('Failed to parse JWT', error);
    return {};
  }
};

export function saveToken(token: string) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    const decoded = parseJwt(token);
    const role = decoded.role;
    localStorage.setItem(ROLE_KEY, role);
  } catch (e) {
    console.error("saveToken failed", e);
  }
}

export function readToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    console.error("readToken failed", e);
    return null;
  }
}

export function readRole(): string | null {
  try {
    return localStorage.getItem(ROLE_KEY);
  } catch (e) {
    console.error("readRole failed", e);
    return null;
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLE_KEY);
  } catch (e) {
    console.error("clearToken failed", e);
  }
}

export function saveAccountId(accountId: string) {
  try {
    localStorage.setItem(ACCOUNT_ID_KEY, accountId);
  } catch (e) {
    console.error("saveAccountId failed", e);
  }
}

export function readAccountId(): string | null {
  try {
    return localStorage.getItem(ACCOUNT_ID_KEY);
  } catch (e) {
    console.error("readAccountId failed", e);
    return null;
  }
}

export function clearAccountId() {
  try {
    localStorage.removeItem(ACCOUNT_ID_KEY);
  } catch (e) {
    console.error("clearAccountId failed", e);
  }
}